import {activationClasses} from "../common/consts";

export class SwitcherComponent {
    readonly active = 'active';

    private switcherControls: HTMLElement[];
    private switcherContents: HTMLElement[];
    private numberItemsShow: HTMLElement[];

    constructor(
        private container: HTMLElement
    ) {
        this.switcherControls
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-switcher-control]'));
        this.switcherContents
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-switcher-content]'));
        this.numberItemsShow =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-number-items-show]'));
    }

    public initialize(): void {
        let currentElementIndex;
        const heightDisplayedElements: number[] = new Array(this.numberItemsShow.length).fill(0);
        const heights: number[] = [];

        this.switcherControls.forEach((switcherControl: HTMLElement, index: number) => {
            if (this.numberItemsShow.length > 0) {
                this.setIInitialSize(this.numberItemsShow[index], this.numberItemsShow, index, heightDisplayedElements);
            }
            let height = this.switcherContents[index].scrollHeight;
            if (this.switcherContents[index]?.dataset?.switcherContent === 'only-mobile' ) {
                if (window.innerWidth < 860) {
                    this.switcherContents[index].classList.remove(activationClasses.active);
                } else {
                    this.switcherContents[index].style.height = 'auto';
                }
            }
            this.switcherContents[index].style.height
                = (this.switcherContents[index].classList.contains(activationClasses.active)
                ? height : heightDisplayedElements[index]) + 'px'
            this.switcherContents[index].style.visibility = 'visible';

            heights.push(this.switcherContents[index].offsetHeight);
            this.hiddenControl(this.switcherContents, index, this.switcherControls);

            switcherControl.addEventListener('click', (e: PointerEvent) => {
                let height = this.switcherContents[index].scrollHeight;
                const initialHeight = heights[index];
                const eventTarget: Element = e.target as Element
                e.stopImmediatePropagation();
                const currentControlMenu: Element | null = eventTarget.closest('[data-control-menu]');
                if (
                    eventTarget
                    && currentControlMenu instanceof HTMLElement
                    && currentControlMenu.dataset.controlMenu === 'item'
                ) { // скорее всего не понадобится
                    return false;
                }
                switcherControl.classList.toggle('active');
                this.switcherContents[index].classList.toggle('active');

                let heightToggle = this.numberItemsShow.length > 0
                    ? heightDisplayedElements[index]
                    : initialHeight;
                if (this.switcherContents[index]?.dataset?.switcherContent
                  === 'only-mobile' ) {
                    if ( window.innerWidth < 860)  {
                        heightToggle = 0;
                    } else {
                        this.switcherContents.forEach((switcherContent: HTMLElement) => {
                            switcherContent.classList.add(activationClasses.active);
                        });
                    }
                }
                this.switcherContents[index].style.height = (this.switcherContents[index].classList.contains('active')
                    ? height : heightToggle) + 'px';
                if (this.switcherContents[index]?.dataset?.switcherContent === 'mobile' && window.innerWidth > 860) {
                    this.switcherContents[index].style.height = 'auto'
                }
                if (
                    this.switcherContents[index]?.dataset.switcherContent
                    === 'default-height' && !this.switcherContents[index].classList.contains('active')
                ) {
                    const div: HTMLDivElement | null = this.switcherContents[index].closest('div')
                    if (this.switcherContents && this.switcherContents.length > 0 && this.switcherContents[index] && div) {
                        this.switcherContents[index].style.height = window.getComputedStyle(div).backgroundSize
                    }
                }
            });

            if (this.switcherContents[index]?.dataset?.switcherContent === 'mobile' && window.innerWidth > 860) {
                this.switcherContents[index].style.height = 'auto'
            }
        });
        window.addEventListener("resize", (event: UIEvent) => {

            let items: NodeListOf<any>;
            const targetElement: Window = event.target as Window;
            if (targetElement) {
                items = targetElement.document.querySelectorAll('[data-switcher-content]');
                items.forEach((item, index) => {
                    heightDisplayedElements[index] = 0;
                    if (items.length > 0) {
                        this.setIInitialSize(items[index], this.numberItemsShow, index, heightDisplayedElements);
                    }

                    if (this.switcherContents[index]?.dataset.switcherContent === 'default-height') {
                        // switcherContents[index].style.height = heights[index] + 'px';
                        const div: HTMLDivElement | null = this.switcherContents[index].closest('div')
                        if (div) {
                            this.switcherContents[index].style.height =
                                window.getComputedStyle(div).backgroundSize
                        }
                    } else {
                        if (this.switcherContents.length - 1 >= index) {
                            this.switcherContents[index].style.height = heightDisplayedElements[index] + 'px';
                        }
                    }

                    if (this.switcherContents[index]?.dataset?.switcherContent === 'mobile' && window.innerWidth > 860) {
                        this.switcherContents[index].style.height = 'auto'
                    }
                    if (items[index]?.classList.contains('active')) {
                        items[index].style.height = 'unset';
                        items[index].style.height = items[index].offsetHeight + 'px';
                    }
                    this.hiddenControl(this.switcherContents, index, this.switcherControls);
                });
            }
        });
    }

    hiddenControl(switcherContents: HTMLElement[], index: number, switcherControls: HTMLElement[]): void {
        if (
            switcherContents[index]?.dataset.switcherContent === 'default-height'

        ) {
            if (
                !switcherContents[index].classList.contains('active')
                && (switcherContents[index].scrollHeight
                    <= switcherContents[index].offsetHeight)
            ) {
                switcherControls[index].classList.add('hidden');
            } else {
                switcherControls[index].classList.remove('hidden');
            }
        }
    }

    setIInitialSize(
        currentItem: HTMLElement,
        numberItemsShow: HTMLElement[],
        index: number,
        heightDisplayedElements: any[]
    ): void {
        currentItem.querySelectorAll('div').forEach(
            (item: HTMLDivElement, indexItem: number): void => {

            const numberItemsShowIndex: string | null =
               numberItemsShow[index]?.getAttribute('data-number-items-show');
            if (
                numberItemsShowIndex &&
                indexItem
                <= parseInt(numberItemsShowIndex, 10) - 1) {
                heightDisplayedElements[index]
                    += item.offsetHeight + parseInt(window.getComputedStyle(item).marginBottom, 10) / 2;
            }
        });
    }
    collapseBlock() {
        this.switcherControls.forEach((switcherControl: HTMLElement, index: number) => {
            if (switcherControl.dataset.switcherControl === 'hidden') {
                const height = this.switcherContents[index].scrollHeight;
                switcherControl.classList.remove('active');
                this.switcherContents[index].classList.remove('active');
                this.switcherContents[index].style.height = (
                    this.switcherContents[index].classList.contains('active') ? height : 0
                ) + 'px' ;
            }
        });
    }
}
